/**
 * wellbeing.js
 * 
 * API for handling getting wellbeing data
 */

import axiosInstance from "./axios-instance";

/**
 * GET request to return wellbeing areas.
 * @returns 
 */
const wellbeingAreas = function () {
    return axiosInstance.get('/app/wellbeing/areas').then(res => res);
}


/**
 * GET request to return client issues data
 * @param {string} query team to filter by
 * @returns Client issues data in format needed for Chartjs
 */
const wellbeingChart = function (type, query) {
    return axiosInstance.get(`/app/wellbeing/chart/${type}${query}`).then(res => res);
}


/**
 * GET request to return wellbeing breakdown data
 * @param {string} label area of wellbeing to filter by
 * @param {string} query filters to apply
 * @returns breakdown data in format needed for Chartjs
 */
const wellbeingBreakdown = function (label, type, query) {
    return axiosInstance.get(`/app/wellbeing/${label}/breakdown/${type}${query}`).then(res => res);
}

export default {
    wellbeingAreas,
    wellbeingChart,
    wellbeingBreakdown
};
